import { render, staticRenderFns } from "./ServiceAppointments.vue?vue&type=template&id=ad18d648&"
import script from "./ServiceAppointments.vue?vue&type=script&lang=js&"
export * from "./ServiceAppointments.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAppointments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports